import img from "@assets/images/thankyou.jpg";
import logo from "@assets/images/Corvell.jpg";

/**
 * Thank You page images
 */
export const images = {
  logo: {
    src: logo,
    alt: "Company Logo",
  },
  thankYou: {
    src: img,
    alt: "Thank You",
  },
};

/**
 * Button configuration
 */
export const buttonConfig = {
  text: "Go to Home",
  iconSize: 22,
};
